import { ref, computed, unref, watch, onMounted, onUnmounted } from 'vue';

// Ticks down a Phorest hold's remaining seconds, recomputed from a fixed deadline each tick
// so a throttled or backgrounded tab cannot drift behind real time.
//
// Accepts a number, a ref or a getter. Given something reactive it restarts when the value
// changes, which the basket sidebar needs - it stays mounted while the basket is refetched.
export function useReservationCountdown(seconds) {
    const read = () => {
        const value = typeof seconds === 'function' ? seconds() : unref(seconds);

        return Math.max(0, Math.floor(value ?? 0));
    };

    // Re-anchored whenever the input changes.
    let deadline = Date.now() + read() * 1000;

    const remaining = ref(read());

    const sync = () => {
        remaining.value = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    };

    watch(read, () => {
        deadline = Date.now() + read() * 1000;
        sync();
    });

    let intervalId = null;

    onMounted(() => {
        sync();
        intervalId = setInterval(sync, 1000);
    });

    onUnmounted(() => clearInterval(intervalId));

    const expired = computed(() => remaining.value <= 0);

    const label = computed(() => {
        const m = Math.floor(remaining.value / 60);
        const s = Math.floor(remaining.value % 60);
        return `${m}:${String(s).padStart(2, '0')}`;
    });

    return { remaining, expired, label };
}
